import React from "react";
import { Helmet } from "react-helmet";
import { useAuth } from "../Store/AuthContext";

export default function HomeMetaData() {
  const { webSetting } = useAuth();
  //   console.log(webSetting);
  return (
    <>
      <Helmet>
        <title>{webSetting.matatitle}</title>
        <meta name="description" content={webSetting.metadesc} />
        <meta name="keywords" content={webSetting.metakeywords} />
        <link rel="canonical" href={window.location.href} />
        <meta property="og:url" content={webSetting.baseURl} />
        <meta property="og:site_name" content={webSetting.website_name} />
        <meta property="og:title" content={webSetting.matatitle} />
        <meta property="og:description" content={webSetting.metadesc} />
        <meta name="search engines" content="ALL" />
        <meta name="Author" content={webSetting.website_name} />
        <meta name="copyright" content={webSetting.baseURl} />
        <meta name="email" content={webSetting.email} />
        <meta property="og:type" content={webSetting.metakeywords} />
      </Helmet>
    </>
  );
}
